export function stringifyArgs(args: Array<unknown>): string {
    return args
        .map((value: unknown) => {
            return typeof(value) === 'object' ? JSON.stringify(value) : value?.toString();
        })
        .join(' - ');
}

export const getNanosecondTimestamp = (): number => (new Date()).getTime() * 1e6;
